export default __webpack_public_path__ + "static/media/challenge-banner.cb8e6bdd.png";